import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import SignUp from '../auth/SignUp';
import SignIn from '../auth/SignIn';

import '../../css/Welcome.css'

class Welcome extends Component {

    state = {
      signUp: false,
    }

    render() {
        document.body.style.backgroundImage = "url('https://miro.medium.com/max/1400/0*o6xpHUxgXlmH5D_w')";
        document.body.style.backgroundSize = "cover";

        const { auth } = this.props;
        
        if (auth.uid) return <Redirect to="/dashboard" />;

        return (
            <div>
                <div id="page-wrap" className="container">
                    <SignIn />
                    <div className="welcome">
                        <div className="welcomeMessage">
                            <h1>Start Now With $100M.</h1>
                            <h3>Build Your Empire.</h3>
                            <h5>"Great resource for learning investment strategy." - Wall St. Trader</h5>
                        </div>
                        <div className="signUpModal">
                            <SignUp />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
    };
};

export default connect(mapStateToProps)(Welcome);
